import { Tipo_garantia } from './../../../models/tipo_garantia.model';
import { Component } from "@angular/core";


@Component({
    selector: "page-tipo_garantia",
    templateUrl: "./tipo_garantia.component.html"
    
})


export class Tipo_garantiaComponent {
    public rows = [];
    public actualRow;
    public tipo_garantia: Tipo_garantia;
    public form;
    public garantia = {"DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA": false, "COPROPIEDAD INMOBILIARIA CON AFECTACION A UTILIDAD PUBLICA": false}
    constructor(){
        if(!JSON.parse(localStorage.getItem("tipo_garantia"))){
            localStorage.setItem("tipo_garantia", JSON.stringify(this.rows));
        }else{
            this.rows = JSON.parse(localStorage.getItem("tipo_garantia"));
            this.garantia = { 
             "DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA": this.rows[0] ? this.rows[0].garantia['DIVISION PREDIAL CON AFECTACION A UTILIDAD PUBLICA'] : false,
             "COPROPIEDAD INMOBILIARIA CON AFECTACION A UTILIDAD PUBLICA": this.rows[0]? this.rows[0].garantia['COPROPIEDAD INMOBILIARIA CON AFECTACION A UTILIDAD PUBLICA'] : false,
            }
        }
    }

    add_tipo_garantia(){
        localStorage.setItem("tipo_garantia",JSON.stringify([]));
        this.actualRow = localStorage.getItem("tipo_garantia");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            garantia: this.garantia
            
          
        })
        localStorage.setItem("tipo_garantia", JSON.stringify(this.rows));
        console.log(JSON.parse(localStorage.getItem("tipo_garantia")));
    }
  
    delete_tipo_garantia(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("tipo_garantia", JSON.stringify(this.rows));
            }
        }
    }   
}